import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Container } from "@/components/site/blocks";
import { useSeo } from "@/components/site/useSeo";
import { api, errorText, getMe } from "@/lib/adminApi";

const inputCls = "mt-2 w-full rounded-xl border border-[#D4AF37]/35 bg-[#12141C] px-4 py-3.5 text-base text-[#F9F8F6] focus:border-[#F3C649]";

export default function AdminLogin() {
  useSeo("Admin sign in", "Private admin area.");
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    getMe().then((u) => { if (alive && u) nav("/admin", { replace: true }); });
    return () => { alive = false; };
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin", { replace: true });
    } catch (err) {
      setError(errorText(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="spotlight min-h-[80vh] pb-24 pt-36" data-testid="admin-login-page">
      <Container className="max-w-md">
        <Lock size={28} aria-hidden="true" className="text-[#F3C649]" />
        <h1 className="mt-6 font-display text-5xl font-semibold">Admin sign in</h1>
        <p className="mt-3 text-[#C8C5BB]">Private access to JEM partnership inquiries.</p>
        <form onSubmit={submit} className="mt-10 space-y-6" aria-label="Admin sign in">
          <div>
            <label htmlFor="admin-email" className="text-sm font-semibold">Email</label>
            <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-email-input" />
          </div>
          <div>
            <label htmlFor="admin-password" className="text-sm font-semibold">Password</label>
            <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-password-input" />
          </div>
          {error && <p role="alert" className="text-sm text-[#FF9C8A]" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-gold w-full justify-center disabled:opacity-70" data-testid="admin-login-submit">
            {busy && <Loader2 size={18} className="animate-spin" aria-hidden="true" />} Sign in
          </button>
        </form>
      </Container>
    </section>
  );
}
